import { Component, Input } from '@angular/core';

import { ActivityEventNames, SearchActivityEvents } from 'generated/graphql';

import { ACTIVITY_EVENT_NAMES } from '../../helpers/activity-event-names';

@Component({
  selector: 'app-activity-event-item',
  templateUrl: './activity-event-item.component.html'
})
export class ActivityEventItemComponent {

  @Input() item: SearchActivityEvents.Node;

  activityEventNames = ACTIVITY_EVENT_NAMES;
  /**
   *
   */
  constructor(
  ) {
  }

  /**
   * Takes event name and returns a string which is used
   * to determine the correct component to display.
   *
   * In most cases, the eventName will be returned unless
   * there is a case in which multiple event names share the same
   * component.
   * For example: email, phone, and address events all use the same
   * component template.
   *
   * @param eventName
   */
  getComponentSwitchString(eventName: ActivityEventNames) {
    if ([ActivityEventNames.CompleteFollowUp, ActivityEventNames.CreateFollowUp, ActivityEventNames.ReassignFollowUp].includes(eventName)) {
      return 'app-follow-up-event';
    }

    if (eventName.includes('phone') || eventName.includes('address') || eventName.includes('email') || eventName.includes('social')) {
      return 'app-contact-info-event';
    }

    if (eventName.includes('tag') && !eventName.includes('mass')) {
      return 'app-response-event';
    }

    if (eventName.includes('contact_attempt') && eventName.includes('action')) {
      return 'app-canvass-attempt-event';
    }

    if (eventName.includes('update_calendar_event_response_status')) {
      return 'app-rsvp-event';
    }

    return eventName;
  }
}
